import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import exportFromBlob from "helpers/export-from-blob";
import FileMenuItem from "components/menu/file-manager/file-menu-item";
import UserTypes from "components/auth/user-types";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
    selectFile,
    deleteFileByFileId,
    createFilesByFolderId,
    getFileInfoById,
    getDownloadFilesByFileId,
    updateFileByFileId
} from "api/menu/file-manager/actions";


const ModalRenameFile = React.lazy(() =>
    import("components/menu/file-manager/modal-rename-file"));

class FilesMenu extends React.Component {
    constructor(props) {
        super(props);

        this.selectFile = this.selectFile.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
        this.handleUploadButton = this.handleUploadButton.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleRename = this.handleRename.bind(this);

        this.uploadInput = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.files, this.props.files)) {
            this.selectFile(false);
        }
    }

    selectFile = (selectedFile) => {
        this.props.selectFile(selectedFile);
    };

    deleteFile = () => {
        const { selectedFile } = this.props;
        if (!selectedFile) {
            return false;
        }

        const element = document.getElementById(`file-manager-file-${selectedFile}`);
        if (!element) {
            return false;
        }
        element.style.opacity = 0;
        element.style.transition = "all 300ms";
        setTimeout(() => {
            element.style.display = "none";
            this.props.deleteFileByFileId(selectedFile);
        }, 350);
    };

    handleUploadButton = () => {
        this.uploadInput.current.click();
    };

    handleUpload = (ev) => {
        const { selectedFolder } = this.props;
        if (!selectedFolder) {
            return false;
        }
        const { files } = ev.target;
        const filesArr = Array.from(files);
        if (!filesArr.length) {
            return filesArr;
        }
        this.props.createFilesByFolderId(selectedFolder, filesArr);
    };

    handleDownload = () => {
        const {
            files,
            selectedFile
        } = this.props;

        const file = files.find(item => parseInt(item.fileId, 10) === parseInt(selectedFile, 10));
        if (!file) {
            return false;
        }

        this.props.getDownloadFilesByFileId(selectedFile, (response) => {
            exportFromBlob(response, file.fileName);
        });
    };

    handleRename = () => {
        const {
            files,
            selectedFile
        } = this.props;
        if (!selectedFile) {
            return false;
        }

        const file = files.find(item => parseInt(item.fileId, 10) === parseInt(selectedFile, 10));
        if (!file) {
            return false;
        }

        const oldFileName = file.fileName;
        const parts = oldFileName.split(".");
        const ext = `.${parts[parts.length - 1]}`;
        const realFileName = file.fileName.replace(ext, "");

        const modalObj = {
            header: "Rename file",
            modalSettings: {
                size: "sm",
            },
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ModalRenameFile
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={fileName => {
                            this.props.updateFileByFileId(file.fileId, {
                                ...file,
                                fileName: `${fileName}${ext}`
                            });
                            this.props.closeCustomModal(modalObj);
                        }}
                        fileName={realFileName}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            userRole,
            files,
            selectedFile,
            selectedFolder
        } = this.props;

        const isEditable = userRole.indexOf(UserTypes.admin) > -1 ||
            userRole.indexOf(UserTypes.accountManager) > -1;


        return (
            <div className="position-relative file-manager-menu">
                <div className="border-bottom p-2 file-manager-title bg-info">
                    <h4 className="p-0 m-0 text-light">Files</h4>
                </div>

                <div className="position-relative file-manager-content">

                    <div className="clearfix">
                        {!isEditable ||
                        <button
                            className="btn btn-primary btn-sm rounded-0 mr-2"
                            disabled={!selectedFolder}
                            onClick={this.handleUploadButton}
                        >
                            Upload
                        </button>
                        }

                        <button
                            className="btn btn-info btn-sm rounded-0 mr-2"
                            disabled={!selectedFile}
                            onClick={this.handleDownload}
                        >
                            Download
                        </button>

                        {!isEditable ||
                        <button
                            className="btn btn-danger btn-sm rounded-0 mr-2"
                            disabled={!selectedFile}
                            onClick={this.deleteFile}
                        >
                            Delete
                        </button>
                        }

                        {!isEditable ||
                        <button
                            className="btn btn-warning btn-sm rounded-0 mr-2"
                            disabled={!selectedFile}
                            onClick={this.handleRename}
                        >
                            Rename
                        </button>
                        }

                        {/* {!isEditable ||
                        <button
                            className="btn btn-dark btn-sm rounded-0 mr-2"
                        >
                            File Traits
                        </button>
                        } */}
                    </div>

                    <table className="table table-hover table-sm">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Upload Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        {files.map(item => (
                            // parentId: null
                            <FileMenuItem
                                key={item.fileId}
                                item={item}
                                onClick={() => this.selectFile(item.fileId)}
                                isActive={selectedFile === item.fileId}
                            />
                        ))}
                        </tbody>
                    </table>

                </div>

                <input
                    ref={this.uploadInput}
                    className="d-none"
                    type="file"
                    multiple={true}
                    onChange={this.handleUpload}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    selectedFolder: state.fileManager.selectedFolder,
    selectedFile: state.fileManager.selectedFile,
    files: state.fileManager.files,
});

const mapStateToDispatch = dispatch => ({
    selectFile: bindActionCreators(selectFile, dispatch),
    deleteFileByFileId: bindActionCreators(deleteFileByFileId, dispatch),
    createFilesByFolderId: bindActionCreators(createFilesByFolderId, dispatch),
    getFileInfoById: bindActionCreators(getFileInfoById, dispatch),
    getDownloadFilesByFileId: bindActionCreators(getDownloadFilesByFileId, dispatch),
    updateFileByFileId: bindActionCreators(updateFileByFileId, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(FilesMenu);
